import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class GetVideoArticleById extends baseRequest
{
    constructor(updateState) {
        super();
        this.name = 'GetVideoArticleById';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = updateState;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload = payload;
        this.call(this.Config.api.requests.getVideoArticleById, payload);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }
}

export default GetVideoArticleById;
